import React from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import {
  AccommodationTableData,
  JobScheduleFormInfo,
  JobScheduleListData,
  JobsAndSiteData,
  JobsAndSiteTableData,
  JobsScheduleTableData,
  TravelListData,
} from './types';
import { Empty } from '../../../ScreenAddSmc/Utils/TypeSmc';
import { formatDateToMMDDYY, stripCustPrefix } from '../../../../utils/CommonFunctions';
import { MasterValue } from '../../../Job/ScreenBidWorkSheetJob/utils/types';

export function formatJobsData(data: JobScheduleListData[]) {
  const res: JobsScheduleTableData[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: JobScheduleListData, index) => {
    const obj = {
      sn: index,
      action: 'schedule',
      jobIdToolTip: [''],
      custId: '',
      customerName: '',
      siteName: '',
      bidName: '',
      cityName: '',
      id: '',
      serialToolTip: [''],
      modelToolTip: [''],
      bidId: '',
      jobId: '',
    };
    obj.id = col.BidId;
    obj.jobIdToolTip = col.UnitIds;
    obj.custId = stripCustPrefix(col.CustId);
    obj.customerName = col.CustomerName;
    obj.siteName = col.SiteName;
    obj.cityName = col.CityName;
    obj.bidName = col.BidName;
    obj.serialToolTip = col.SerialNumber;
    obj.modelToolTip = col.Model;
    obj.bidId = col.BidId;
    obj.jobId = col.JobId;

    res.push(obj);
  });

  return res;
}

export function formatJobsDataXl(data: JobScheduleListData[]) {
  const res: Empty = [];

  if (data?.length === 0) return [];

  data?.forEach((col: JobScheduleListData) => {
    const obj = {
      JobId: '',
      CustId: '',
      Customer: '',
      Site: '',
      BidName: '',
      city: '',
      SerialNumber: '',
      Model: '',
      BidId: '',
    };
    obj.JobId = col.UnitIds.join(', ');
    obj.CustId = stripCustPrefix(col.CustId);
    obj.Customer = col.CustomerName;
    obj.Site = col.SiteName;
    obj.city = col.CityName;
    obj.BidName = col.BidName;
    obj.SerialNumber = col.SerialNumber.join(', ');
    obj.Model = col.Model.join(', ');
    obj.BidId = col.BidId;

    res.push(obj);
  });

  return res;
}

export function accommodationJobsData(data: TravelListData[]) {
  const res: AccommodationTableData[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: TravelListData, index) => {
    const obj = {
      sn: index,
      action: 'edit&delete',
      HotelName: '',
      dateIn: '',
      dateOut: '',
      cityName: '',
      phoneNumber: '',
      ConfirmationCode: '',
      id: 0,
    };

    obj.HotelName = col.HotelName;
    obj.dateIn = formatDateToMMDDYY(col.DateIn);
    obj.dateOut = formatDateToMMDDYY(col.DateOut);
    obj.cityName = col.CityName;
    obj.phoneNumber = col.PhoneNumber;
    obj.ConfirmationCode = col.ConfirmationCode || '';
    obj.id = col.HotelId;

    res.push(obj);
  });

  return res;
}

export function jobsAndSiteData(data: JobsAndSiteData[], analystList: MasterValue[]) {
  const res: JobsAndSiteTableData[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: JobsAndSiteData, index) => {
    const obj = {
      sn: index,
      Manufacturer: '',
      ModelNumber: '',
      SerialNumber: '',
      tubeCount: '',
      analystAction_nosort: '',
      syncByAction_nosort: '',
      reTest: false,
      jobOrder_nosort: '' as string | JSX.Element,
      vesselToolTip: [''],
      reportAction_nosort: 'add',
      equipmentToolTip: [''],
      id: '',
      IsReadyToSend: false,
      IsReportPresent: false,
    };

    obj.Manufacturer = col.Manufacturer;
    obj.ModelNumber = col.ModelNumber;
    obj.SerialNumber = col.SerialNumber;
    obj.tubeCount = col.TubeCount;
    obj.reTest = col.ReTest !== 'No';
    // eslint-disable-next-line react/react-in-jsx-scope
    obj.jobOrder_nosort = col.ScheduleDetails ? (
      <Link to={`/job-order/${col.UnitId}`} className="JobOrderLink">
        {col.UnitId}
      </Link>
    ) : '';
    obj.id = col.UnitId;
    obj.vesselToolTip = col?.Vessel || [];
    obj.equipmentToolTip = col?.Equipment || [];
    obj.analystAction_nosort = col.ScheduleDetails ? { analystList, ...col.ScheduleDetails } : col.ScheduleDetails;
    obj.syncByAction_nosort = col.ScheduleDetails ? col.ScheduleDetails.AnalystName : '';
    obj.IsReadyToSend = col.IsReadyToSend || false;
    obj.IsReportPresent = col.IsReportPresent;
    res.push(obj);
  });

  return res;
}

export function formatHotelListData(data: TravelListData[]) {
  const res: AccommodationTableData[] = [];

  if (data?.length === 0) return [];

  data?.forEach((col: TravelListData, index) => {
    const obj = {
      sn: index,
      action: 'edit&delete',
      stateName: '',
      dateIn: '',
      price: '',
      cityName: '',
      HotelName: '',
      jobCode: '',
      phoneNumber: '',
      id: '',
    };

    obj.stateName = col.StateName;
    obj.dateIn = formatDateToMMDDYY(col.DateIn);
    obj.price = `$ ${col.Price}`;
    obj.cityName = col.CityName;
    obj.HotelName = col.HotelName;
    obj.phoneNumber = col.PhoneNumber || '';
    obj.id = col.HotelId;
    obj.jobCode = col.JobCode;

    res.push(obj);
  });

  return res;
}
// eslint-disable-next-line max-len
export function getFormValues(values:JobScheduleFormInfo, bidId: Empty, travelDetailsValues: Empty, commentValues: string, instructionsValues: string) {
  return {
    BidId: bidId,
    TravelInfo: {
      Direction: travelDetailsValues?.travelDirection || '',
      FlightOutDate: values?.flightOutDate ? dayjs(values?.flightOutDate).format('DD-MM-YYYY') : null,
      ToOut: values?.flightToOutDate ? dayjs(values?.flightToOutDate).format('DD-MM-YYYY') : null,
      FlightOutAirlines: travelDetailsValues?.flightOutAirline || '',
      FlightOutDepartureTime: travelDetailsValues?.flightOutdepartureTime ? dayjs(travelDetailsValues?.flightOutdepartureTime).format('hh:mm A') : '',
      FlightOutArrivalTime: travelDetailsValues?.flightOutarivalTime ? dayjs(travelDetailsValues?.flightOutarivalTime).format('hh:mm A') : '',
      FlightOutSeat: travelDetailsValues?.flightOutSeat || 0,
      FlightOutConfirmation: travelDetailsValues?.flightOutConfirmation,
      FlightInDate: values?.flightInDate ? dayjs(values?.flightInDate).format('DD-MM-YYYY') : null,
      ToIn: values?.flightToInDate ? dayjs(values?.flightToInDate).format('DD-MM-YYYY') : null,
      FlightInAirlines: travelDetailsValues?.flightInAirline || '',
      FlightInDepartureTime: travelDetailsValues?.flightIndepartureTime ? dayjs(travelDetailsValues?.flightIndepartureTime).format('hh:mm A') : '',
      FlightInArrivalTime: travelDetailsValues?.flightInarivalTime ? dayjs(travelDetailsValues?.flightInarivalTime).format('hh:mm A') : '',
      FlightInSeat: travelDetailsValues?.flightInSeat || 0,
      FlightInConfirmation: travelDetailsValues?.flightInConfirmation,
      CarRentalCompany: travelDetailsValues?.carRentalCompany || '',
      CarRentalPhone: travelDetailsValues?.carRentalPhone || '',
      CarRentalPrice: travelDetailsValues?.carRentalPrice || 0,
      CarRentalConfirmationNumber: travelDetailsValues?.carRentalConfirmation || '',
      CarRentalInstruction: travelDetailsValues?.carInstruction || '',
    },
    SchedulingInstruction: {
      Comment: commentValues || '',
      Instruction: instructionsValues || '',
    },
  };
}

export function setValuesForm(setValue: SetValue, JobScheduleFields: JobScheduleFormInfo) {
  setValue(JobScheduleFields.hotelMotel, '');
  setValue(JobScheduleFields.hotelAddress, '');
  setValue(JobScheduleFields.hotelZip, '');
  setValue(JobScheduleFields.hotelCity, '');
  setValue(JobScheduleFields.hotelState, '');
  setValue(JobScheduleFields.hotelAddressOptional, '');
  setValue(JobScheduleFields.hotelConfirmation, '');
  setValue(JobScheduleFields.hotelPrice, '');
  setValue(JobScheduleFields.late, false);
}
